export default __webpack_public_path__ + "static/media/arrow-hover.51118170.svg";